import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import {RoleModel} from "@services/back-office/model/roleModel";

export enum RolesActionTypes {
  LoadRoles = '[Roles] Load Roles',
  LoadRolesSuccess = '[Roles] Load Roles Success',
  LoadRolesFailure = '[Roles] Load Roles Failure',
  AddRoles = '[Roles] Add Roles',
  AddRolesSuccess = '[Roles] Add Roles Success',
  AddRolesFailure = '[Roles] Add Roles Failure',
  EditRoles = '[Roles] Edit Roles',
  EditRolesSuccess = '[Roles] Edit Roles Success',
  EditRolesFailure = '[Roles] Edit Roles Failure',
  DeleteRoles = '[Roles] Delete Roles',
  DeleteRolesSuccess = '[Roles] Delete Roles Success',
  DeleteRolesFailure = '[Roles] Delete Roles Failure',
  SetInitialState = '[Roles] Set Initial State',
}

/** Load Roles */
export class LoadRoles implements Action {
  readonly type = RolesActionTypes.LoadRoles;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadRolesSuccess implements Action {
  readonly type = RolesActionTypes.LoadRolesSuccess;
  constructor(public payload: RoleModel[]) { }
}

export class LoadRolesFailure implements Action {
  readonly type = RolesActionTypes.LoadRolesFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Add Roles */
export class AddRoles implements Action {
  readonly type = RolesActionTypes.AddRoles;
  constructor(public payload: RoleModel) {}
}

export class AddRolesSuccess implements Action {
  readonly type = RolesActionTypes.AddRolesSuccess;
  constructor(public payload: RoleModel) { }
}

export class AddRolesFailure implements Action {
  readonly type = RolesActionTypes.AddRolesFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Edit Roles */
export class EditRoles implements Action {
  readonly type = RolesActionTypes.EditRoles;
  constructor(public payload: {roleId: string, request: RoleModel}) {}
}

export class EditRolesSuccess implements Action {
  readonly type = RolesActionTypes.EditRolesSuccess;
  constructor(public payload: RoleModel) { }
}

export class EditRolesFailure implements Action {
  readonly type = RolesActionTypes.EditRolesFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Delete Roles */
export class DeleteRoles implements Action {
  readonly type = RolesActionTypes.DeleteRoles;
  constructor(public payload: string) {}
}

export class DeleteRolesSuccess implements Action {
  readonly type = RolesActionTypes.DeleteRolesSuccess;
  constructor(public payload: void) { }
}

export class DeleteRolesFailure implements Action {
  readonly type = RolesActionTypes.DeleteRolesFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = RolesActionTypes.SetInitialState;
}

export type RolesActions =
  | LoadRoles
  | LoadRolesSuccess
  | LoadRolesFailure
  | AddRoles
  | AddRolesSuccess
  | AddRolesFailure
  | EditRoles
  | EditRolesSuccess
  | EditRolesFailure
  | DeleteRoles
  | DeleteRolesSuccess
  | DeleteRolesFailure
  | SetInitialState
  ;

